import React, { useEffect, useState, useRef } from 'react';
import { Image, Text, TouchableOpacity, View, ActivityIndicator } from 'react-native';
import Header from '../../common/Header';
import * as RootNavigation from '../../utilities/RootNavigation';
import CImage from '../../common/CImage';
import CustomButton from '../../common/CustomButton';
import applicationStyles from '../../styles/applicationStyles';
import CustomTextInput from '../../common/CustomTextInput';
import CustomInput from '../../common/CustomInput';
import LoginTabIcons from './LoginTabIcons';
import LoginRightWidget from './LoginRightWidget';
import LoginMoibleContent from './LoginMobileContent';
import LoginFooter from './LoginFooter';
import { sendOtp, validateOtp, getEncKey,getCpatcha } from '../../api/apiManager';
import CountdownTimer from '../../common/CTimer.web';
import useStyles from './UnlockUserScreen_Styles';
import CView from '../../styles/CommonStyle';
import { COLORS } from '../../constant';
import CCaptcha from '../../common/CCaptcha';
import { Encryption as encrypt,decryptCaptcha ,encryptCaptcha} from '../../utilities/Encryption';
export default function UnlockUserScreen() {
  const otpPattern = /^\d{6}$/;
  const styles = useStyles();
  const [otp, setOtp] = useState('');
  const [otpResponse, setOtpResponse] = useState('');
  const [screenName, setScreenName] = useState('1');
  const [mobile, setMobile] = useState('');
  const [isLoading, setIsLoading] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [captchaId, setCaptchaId] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const counterRef = useRef(null);

  useEffect(()=>{
    generateCaptcha();
  },[])
  const generateCaptcha = () => {
   setCaptcha("")
    getCpatcha()
      .then((res) => {
        decryptCaptcha(res?.data).then((res) => {
          setCaptchaText(res?.captchaCode)
          setCaptchaId(res?.captchaId)
        });
      }).catch((err) => {
        const routeObj = { title: "Captcha", type: "Error", msg: err?.response?.data?.message, btnText: "Ok", navigation: "Login", }
        RootNavigation.navigate("ResponseScreen", { data: routeObj })
      });
  };
  const onClickGetOtp = () => {
    getEncKey()
      .then(async (res) => {
        if (res.statusCode == 200) {
          const encKey = res?.data || '';
          const encryptedCaptcha = await encrypt(`${captchaId}:${captcha}`, encKey);
          let reqObj = {
            type: 'unlockUserWithCaptcha',
            id: mobile,
            captcha: encryptedCaptcha,
          };
          console.log(reqObj)
          console.log(captcha,captchaId)
          onSendOtp(reqObj);
        }
      })
      .catch((err) => {
        const routeObj = { title: 'Login ', type: 'Error', msg: err?.response?.data?.message, btnText: 'Ok', navigation: 'Login' };
        RootNavigation.navigate('ResponseScreen', { data: routeObj });
      });
  };
  const resendOTP = () => {
    setOtp('');

    let reqObj = {
      type: 'unlockUserWithCaptcha',
      requestId: otpResponse?.response?.otp,
      id: mobile,
    };
    onSendOtp(reqObj);
  };
  const onSendOtp = (reqObj) => {
    sendOtp(reqObj)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.statusCode == 1003) {
          setScreenName('2');
          setOtpResponse(res?.data);
        } else if (res?.data?.statusCode == -1004 || res?.data?.statusCode == -1019 || res?.data?.statusCode == -1003 || res?.data?.statusCode == 500 || res?.data?.statusCode < 0 ) {
          const routeObj = {
            title: 'Unlock USer Id',
            type: 'error',
            msg: res?.data?.message,
            btnText: 'Ok',
            navigation: 'UnlockUserScreen',
          };
          RootNavigation.navigate('ResponseScreen', { routeObj });
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const onValidateOtp = () => {
    let reqObj = {
      type: 'unlockUserWithCaptcha',
      otp: otp,
      requestId: otpResponse?.response?.otp,
      userId: mobile,
    };
    validateOtp(reqObj)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.statusCode == 1019) {
          const routeObj = {
            title: 'Unlock USer Id',
            type: 'success',
            msg: res?.data?.message,
            btnText: 'Ok',
            navigation: 'Login',
          };
          RootNavigation.navigate('ResponseScreen', { routeObj });
        } else if (res?.data?.statusCode < 0) {
          const routeObj = {
            title: 'Unlock USer Id',
            type: 'Error',
            msg: res?.data?.message,
            btnText: 'Ok',
            navigation: 'UnlockUserScreen',
          };
          setScreenName('1');
          RootNavigation.navigate('ResponseScreen', { routeObj });
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const renderUnlockUserScreen = () => {
    return (
      <View style={styles.containerBox}>
        <View style={styles.rectangle41}>
          <TouchableOpacity onPress={() => RootNavigation.navigate('SelectUnlockScreen')}>
            <CImage.BackIconWhite></CImage.BackIconWhite>
          </TouchableOpacity>
          <Text style={[applicationStyles.loginTextStyle]}>{'Unlock User ID'}</Text>
        </View>
        {screenName == '1' ? (
          <>
            <CView
              AC
              ASC
              W80>
              <Text style={styles.userText}>{'Enter User Id.'}</Text>
              <CView
                MT={20}
                W100>
                <CustomTextInput
                  value={mobile}
                  onChangeText={setMobile}
                  placeholder={'Enter User Id.'}
                />
                <Image
                  source={require('../../assets/images/UID.png')}
                  style={styles.iconUID}
                />
              </CView>
              <CView W100>
                <CCaptcha  captcha={captcha} setCaptcha={setCaptcha} setCaptchaText={setCaptchaText} setCaptchaId={setCaptchaId} captchaText= {captchaText}/>
              </CView>

              <CView
                MT={30}
                W100
                height={37}>
                <CustomButton
                  onPress={!mobile ? ()=>{} : captcha !== captchaText ? ()=>{} : onClickGetOtp}
                  text={'Get OTP'}
                  disable={!mobile || !captcha || captcha !== captchaText }
                />
                {isLoading && (
                  <ActivityIndicator
                    size={'large'}
                    color='#707070'
                    style={styles.spinner}
                  />
                )}
              </CView>
            </CView>
          </>
        ) : screenName == '2' ? (
          <CView
            W80
            ASC>
            <Text style={applicationStyles.enterOtpDescStyle}>{otpResponse?.message}</Text>
            <Text style={applicationStyles.enterOtpTxtStyle}>{'Enter OTP'}</Text>
            <CustomInput
              value={otp}
              onValueChanged={(e) => setOtp(e)}
              style={[styles.textInputStyle, { width: 280 }]}
              maxLength={6}
              pattern={/^\d{6}$/}
              errorMessage={'Enter Valid OTP'}
              type='number'
              keyboardType='numeric'
            />
            <View style={styles.resendViewStyle}>
              <CountdownTimer
                requestOtp={screenName == '2'}
                onClickGetOtp={resendOTP}
                counterRef={counterRef}
              />
            </View>
            <CView
              ASC
              MT={25}
              width={108}
              height={37}>
              <CustomButton
                onPress={!otpPattern.test(otp) ? ()=>{} : onValidateOtp}
                text={'Submit'}
                disable={!otpPattern.test(otp) ? true : false}
              />
            </CView>
          </CView>
        ) : null}
      </View>
    );
  };

  return (
    <CView W100 HW>
      <CView flex={1}>
        <Header text={'Login'} />
        <View style={styles.bodyContainerStyle}>
          <CView BG={COLORS.grayOP69} flex={0.4} AC JC>
            {renderUnlockUserScreen()}
            <LoginTabIcons />
          </CView>
          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.logoWidget}>
            <CView FR>
              <CImage.IDFCLogo></CImage.IDFCLogo>
            </CView>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View style={styles.widgetCenter}>{renderUnlockUserScreen()}</View>
          <LoginMoibleContent />
        </View>
        <LoginFooter />
      </CView>
    </CView>
  );
}
